"use client";

import { createContext, useMemo, type ReactNode } from "react";
import TealiumUniversalTag, {
  type TealiumUniversalTagOptions,
} from "../lib/TealiumUniversalTag";
import TealiumWithGlobalData from "./withGlobalData";
import { useEventHandlers } from "./events";

export const TealiumContext = createContext<TealiumWithGlobalData>(
  {} as TealiumWithGlobalData,
);
export const TealiumConsumer = TealiumContext.Consumer;

export type TealiumProviderProps = TealiumUniversalTagOptions & {
  children: ReactNode;
};

export const TealiumProvider = ({
  children,
  ...props
}: TealiumProviderProps) => {
  if (typeof window !== "undefined") {
    const disableTealiumInjectedInlinkOutlinkTracking = {
      tealiumInjectedInlinkOutlinkTracking: "tealium-universal-tag-context",
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any
    (window as any).tealiumMousedownEventListener =
      disableTealiumInjectedInlinkOutlinkTracking;
  }

  const tealium = useMemo(
    () =>
      new TealiumWithGlobalData(
        new TealiumUniversalTag({ manualPageView: true, ...props }),
      ),
    Object.values(props),
  );

  useEventHandlers(tealium);

  return (
    <TealiumContext.Provider value={tealium}>
      {children}
    </TealiumContext.Provider>
  );
};
